import { useRef, useEffect } from "react";
import { useConfigContext } from "@/ConfigProvider";
import { useAutocomplete } from "@/autocomplete/context/GlobalContext";
import { useMinimalSearchVisibility } from "@/autocomplete/hooks/useMinimalSearchVisibility";
import { useAnimatedPlaceholder } from "@/autocomplete/hooks/useAnimatedPlaceholder";
import { SearchInput } from "@/autocomplete/components/SearchInput";


type MobileSearchFieldProps = {
    headerHeight: number;
}

export function MobileSearchField({ headerHeight }: MobileSearchFieldProps) {
    const {
        autocomplete,
        autocompleteState: { query },
    } = useAutocomplete();

    const mobileInputRef = useRef<HTMLInputElement>(null);
    const { tc } = useConfigContext();
    const showModalSearch = useMinimalSearchVisibility();

    const placeholders = [
        tc.search_placeholder_text_1,
        tc.search_placeholder_text_2,
        tc.search_placeholder_text_3,
        tc.search_placeholder_text_4,
        tc.search_placeholder_text_5,
        tc.search_placeholder_text_6,
    ];
    useAnimatedPlaceholder(mobileInputRef, placeholders, showModalSearch);

    const { isModalOpen } = useAutocomplete();

    useEffect(() => {
        if (isModalOpen && showModalSearch && mobileInputRef.current) {
            mobileInputRef.current.focus();
        }
    }, [isModalOpen, showModalSearch]);

    const mobileFormProps = autocomplete.getFormProps({ inputElement: mobileInputRef.current });
    const mobileInputProps = autocomplete.getInputProps({ inputElement: mobileInputRef.current });

    if (!showModalSearch) {
        return null;
    }

    return (
        <div className="algoliaAutocompleteModal__mobileSearch" style={{ top: `${headerHeight}px` }}>
            <form
                className="algoliaAutocompleteForm algoliaAutocompleteForm--mobile is-loaded"
                {...mobileFormProps}
            >
                <div className="inputGroup searchBar searchBar--dynamicPlaceholders algoliaAutocompleteForm__searchBar">
                    <label className="algoliaAutocompleteForm__label" {...autocomplete.getLabelProps({})}>
                        <button className="inputGroup__addon" type="submit" aria-label={tc.search} title={tc.search}>
                            <i className="icon icon-search" aria-hidden="true"></i>
                        </button>
                    </label>
                    <SearchInput
                        ref={mobileInputRef}
                        {...mobileInputProps}
                        value={query}
                        query={query}
                    />
                    <div className="dynamicPlaceholders__container">
                        <div className="inner">
                            <div className="searchPlaceholder">{tc.search_placeholder}</div>
                            <div className="dynamicPlaceholders">
                                {placeholders[0] && (
                                    <div className="placeholder-text current">
                                        <span>{placeholders[0]}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {query && (
                        <button className="algoliaAutocompleteForm__clear" title="Clear" type="reset">
                            <i className="icon icon-close" aria-hidden={true}></i>
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
}